export default __webpack_public_path__ + "static/media/a6ccf9e66e690f4f.bc01ca3c2293a117c59d1c5063f1e117.svg";